import { render, staticRenderFns } from "./JPopupOnlReport.vue?vue&type=template&id=4f5ed88d&scoped=true"
import script from "./JPopupOnlReport.vue?vue&type=script&lang=js"
export * from "./JPopupOnlReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5ed88d",
  null
  
)

export default component.exports